// Material UI
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      marginBottom: theme.spacing(2),
      '& > *': {
        margin: theme.spacing(1),
        padding: theme.spacing(4, 4),
        width: '100%',
        height: 'auto',
        [theme.breakpoints.down('xs')]: {
          padding: theme.spacing(4, 2),
        },
      },
      '& > .MuiPaper-root': {
        minHeight: '58vh',
        [theme.breakpoints.down('xs')]: {
          height: 'auto',
          minHeight: 'auto'
        },
      }
    },
    sectionTitle: {
      flexGrow: 1,
    },
    boxTop: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      marginBottom: theme.spacing(2),
      '& > *': {
        marginRight: theme.spacing(2),
      },
    },
    rowTotal: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      marginTop: theme.spacing(2),
      '& > *': {
        marginBottom: theme.spacing(1),
      },
    },
    rowActions: {
      display: 'flex',
      justifyContent: 'flex-end',
      flexDirection: 'row',
      marginBottom: theme.spacing(2),
      marginTop: theme.spacing(2),
      '& > *': {
        marginRight: theme.spacing(2),
      },
    },
    rowNotes: {
      display: 'flex',
      textAlign: 'right',
      flexDirection: 'column',
      '& > *': {
        width: '100%',
        marginRight: theme.spacing(2),
      },
    }
  }),
);

export default useStyles;
